import { BirdviewDweller } from '../BirdviewDweller'
import { BirdviewOperational } from '../BirdviewOperational'
import { BirdviewOversight } from '../BirdviewOversight'
import { BirdviewSkeleton } from '../DashboardBirdview.constants'

export function getBirdviewDashboardViewContent({
  activityDoneById,
  pendingIds,
  requestActions,
  role,
  scope,
  sections,
  skeleton,
  storageScope,
  onActivityToggle,
  onNavigate,
}) {
  switch (skeleton) {
    case BirdviewSkeleton.Oversight:
      return (
        <BirdviewOversight
          activityDoneById={activityDoneById}
          pendingIds={pendingIds}
          requestActions={requestActions}
          scope={scope}
          sections={sections}
          storageScope={storageScope}
          onActivityToggle={onActivityToggle}
          onNavigate={onNavigate}
        />
      )
    case BirdviewSkeleton.Dweller:
      return (
        <BirdviewDweller
          role={role}
          sections={sections}
          storageScope={storageScope}
          onNavigate={onNavigate}
        />
      )
    default:
      return (
        <BirdviewOperational
          activityDoneById={activityDoneById}
          pendingIds={pendingIds}
          requestActions={requestActions}
          sections={sections}
          storageScope={storageScope}
          onActivityToggle={onActivityToggle}
          onNavigate={onNavigate}
        />
      )
  }
}
